import { render, staticRenderFns } from "./UiPageHeader.vue?vue&type=template&id=c47f0366&"
import script from "./UiPageHeader.vue?vue&type=script&lang=ts&"
export * from "./UiPageHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports